import HamburguerMenu from './HamburgerMenu'
import PropTypes from 'prop-types'
import React from 'react'
import SubscribeButton from './SubscribeButton'
import TagLogo from './TagLogo'
import styled from 'styled-components'
import { useHome } from '@site/contexts/homeContext'

const SmallMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 24px;
  position: fixed;
  top: 0;
  width: 100%;
  height: 48px;
  background: white;
  box-shadow: 0 1px 4px rgb(19 26 45 / 20%);
  z-index: 4;
`
const IconAndLogoWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: auto;

  & > a {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 5px;

    & > svg {
      transform: scale(0.8);
    }
  }
`

const ContractedHamburguerMenu = ( { onClickHamburgerMenu } ) => {
  const { onClickSubscribe } = useHome()

  return (
    <SmallMenuWrapper data-testid="small-menu">
      <IconAndLogoWrapper>
        <HamburguerMenu onClick={ onClickHamburgerMenu } />
        <TagLogo logoColor="blue" />
      </IconAndLogoWrapper>
      <SubscribeButton
        onClick={ onClickSubscribe }
      />
    </SmallMenuWrapper>
  )
}

ContractedHamburguerMenu.propTypes = {
  'onClickHamburgerMenu': PropTypes.func.isRequired,
  'setShowSubscribeModal': PropTypes.func.isRequired,
}

export default ContractedHamburguerMenu
